<template>
    <header class="header">
        <div class="navbar-fixed">
            <nav class="header-supploer-guest-desktop">
                <div class="container">
                    <a
                        @click="$emit('push-route', { url: 'LandingPage', solo: false })"
                        class="brand-logo-contractor-guest-desktop"
                    >
                        <img src="@/assets/images/engelink_logo.svg" alt="Engelink" />
                    </a>
                    <ul class="contractor-guest-menu-top-desktop">
                        <li
                            class="im-supplier-title"
                            :class="[{ 'active-link': $route.name === 'CompetitionDashboardGuest' }]"
                            @click="$emit('push-route', { url: 'CompetitionDashboardGuest', solo: false })"
                        >
                            <span
                                class="contractor-guest-title-menu im-supplier-title"
                            >Sou fornecedor</span>
                        </li>
                        <li
                            :class="[{ 'active-link': $route.name === 'NetworkSuppliers' }]"
                            @click="$emit('push-route', { url: 'NetworkSuppliers', solo: false })"
                        >
                            <span
                                class="contractor-guest-title-menu supplier-guide-title"
                            >Guia de Fornecedores</span>
                        </li>
                        <li
                            @click="$emit('push-route', { url: 'https://blog.engelink.com.br/', solo: true })"
                        >
                            <span class="contractor-guest-title-menu">Blog</span>
                        </li>
                        <li
                            @click="$emit('push-route', { url: 'https://condo.news/', solo: true })"
                        >
                            <span class="contractor-guest-title-menu">CondoNews</span>
                        </li>
                        <li
                            :class="[{ 'active-link': $route.name === 'CondoTechsLandingpage' }]"
                            @click="$emit('push-route', { url: 'CondoTechsLandingpage', solo: false })"
                        >
                            <span class="contractor-guest-title-menu">Condotechs</span>
                        </li>
                        <li @click="$emit('push-route', { url: 'https://pages.engelink.com.br/materiais', solo: true })"
                        >
                            <span class="contractor-guest-title-menu">Materiais</span>
                        </li>
                        <li
                            :class="[{ 'active-link': $route.name === 'ContactUs' }]"
                            @click="$emit('push-route', { url: 'ContactUs', solo: false })"
                        >
                            <span class="contractor-guest-title-menu">Fale conosco</span>
                        </li>
                        <div>
                            <a
                                class="waves-effect waves-light btn btn-signup-contractor-guest"
                                @click="$emit('push-route', { url: 'Login', solo: false })"
                            >{{ hasKey ? 'Painel' : 'Entrar' }}</a>
                            <a
                                class="waves-effect waves-light btn btn-signup-contractor-guest-signup"
                                @click="$emit('push-route', { url: 'Signup', solo: false })" v-if="!hasKey"
                            >Cadastre-se</a>
                        </div>
                    </ul>
                </div>
            </nav>
        </div>
    </header>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'HeaderContractorGuestDesktop',
    computed: {
        ...mapState('user', ['user']),
        hasKey() {
            return this.user.key ? this.user.key : false
        },
    },
};
</script>

<style lang="scss">
.header-supploer-guest-desktop {
    background-color: #ffffff;
    z-index: 999 !important;
    height: 53px;
    line-height: 53px;
    box-shadow: 0px 3px 6px #00000029;
}

.header-supploer-guest-desktop .container {
    display: flex;
    justify-content: center;
    justify-items: space-between;
}

.brand-logo-contractor-guest-desktop {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
}
.contractor-guest-menu-top-desktop {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
}
.contractor-guest-menu-top-desktop li .im-supplier-title {
    color: #007bff;
    font-weight: 600;
}
// .contractor-guest-menu-top-desktop li {
// }

.contractor-guest-menu-top-desktop li {
    display: inline-block;
    position: relative;
    cursor: pointer;
    font-size: 16px;
    color: #707070;
}

.contractor-guest-menu-top-desktop li .contractor-guest-title-menu {
    padding-inline: 10px;
}

.contractor-guest-menu-top-desktop li:hover {
    transition: 0.3s;
    color: #000;
}

.contractor-guest-menu-top-desktop li.active-link {
    transition: 0.3s;
    color: #000;
}
.contractor-guest-menu-top-desktop li.active-link:after {
    content: "";
    position: relative;
    bottom: 4px;
    display: block;
    margin: auto;
    height: 4px;
    width: 0px;
    background: transparent;
    transition: width 0.3s ease, background-color 0.3s ease;
}

.contractor-guest-menu-top-desktop li.active-link:after {
    width: 100%;
    background: #000;
}
.contractor-guest-menu-top-desktop .im-supplier-title:hover:after {
    width: 100%;
    background: #007bff;
}
.btn-signup-contractor-guest {
    color: #007bff;
    background-color: #fff;
    border: solid 1px #007bff;
    box-shadow: none !important;
    text-transform: none;
    font-size: 16px;
    margin-right: 16px !important;
    font-weight: 600;
    padding: 10px;
    height: 40px;
    border-radius: 3px !important;
    line-height: 18px;
}
.btn-signup-contractor-guest:hover {
    color: #007bff;
    background-color: #fff;
}
.btn-signup-contractor-guest-signup {
    box-shadow: none !important;
    color: #fff;
    background-color: #007bff;
    border: solid 1px #007bff;
    text-transform: none;
    font-size: 16px;
    margin-left: 0px !important;
    margin-right: 0px !important;
    font-weight: 600;
    height: 40px;
    padding: 10px;
    border-radius: 3px !important;
    line-height: 18px;
}
.btn-signup-contractor-guest-signup:hover {
    color: #007bff;
    background-color: #fff;
}
</style>
